import React, { useEffect, useRef } from 'react';
// import { Button } from 'antd';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus } from '@fortawesome/free-solid-svg-icons';
// import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useCondicionesAlarma from './useCondicionesAlarma';
import styles from './CondicionesAlarma.module.less';

import GroupCondition from './GroupCondition';
import LayoutStep from '../../components/LayoutStep';
import TagCondition from '../../components/TagCondition';

function CondicionesAlarma(props) {

  // const { t } = useTranslation();
  const count = useRef(0);
  const { form, onPrevious, onNext } = props;
  const {
    conditions,
    // addNewGroupConditions,
    // isEditDefault,
  } = useCondicionesAlarma({
    form,
  });
  useEffect(() => {

    count.current += 1;

  });

  return (
    <LayoutStep onPrevious={onPrevious} onNext={onNext}>
      {conditions.map((conditionsOr, index) => {

        const key = `group_${index}_${count.current}`;
        const isLastCondition = index === conditions.length - 1;
        return (
          <div key={key}>
            <GroupCondition index={index} />

            {!isLastCondition && (
              <div className={styles.group_separator}>
                <div className={styles.line_separator} />
                <TagCondition type="y" />
                <div className={styles.line_separator} />
              </div>
            )}
          </div>
        );

      })}
      {/* <Button
        type="dashed"
        style={{ alignSelf: 'flex-start', marginTop: 20 }}
        onClick={() => addNewGroupConditions()}
        disabled={isEditDefault}
      >
        <FontAwesomeIcon icon={faPlus} style={{ marginRight: 12 }} />
        {t('views.dynamic_alarms_create_edit.buttons.add_new_group')}
      </Button> */}
    </LayoutStep>
  );

}

CondicionesAlarma.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default CondicionesAlarma;
